import React from "react";

export const ReactIsInDevelomentMode = function () {
    return '_self' in React.createElement('div');
}